import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import YouTube from 'react-youtube';
import CloseIcon from '@mui/icons-material/Close';

import { useTranslation } from 'react-i18next';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
    	padding: theme.spacing(2),
  	},
  	'& .MuiDialogActions-root': {
    	padding: theme.spacing(1),
  	},
}));

export default function DisplayVideo(props) {

  	const handleClose = () => {
    	props.handleDisplayVideo(false);
  	};

  	const { t, i18n } = useTranslation("",{lng: props.language});

    const opts = {
      height: '390',
      width: '100%',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
      },
    };

  	return (
    	<React.Fragment>
      		<BootstrapDialog 	open={props.display}
			        			onClose={handleClose}
			        			aria-labelledby="alert-dialog-title"
			        			aria-describedby="alert-dialog-description"
								sx={{
								      "& .MuiDialog-container": {
								        "& .MuiPaper-root": {
								          width: { xs: "360px", md: "720px", lg: "720px" } ,
								          minWidth: { xs: "360px", md: "720px", lg: "720px" },  
								        },
								      },
								}}
			>
				<DialogTitle id="alert-dialog-title">
	         		{t("Kennen Sie schon unseren Ford Triostyle???")}
	        	</DialogTitle>
				<IconButton aria-label="close"
			          			onClick={handleClose}
			          			sx={{  	position: 'absolute',
			            				right: 8,
			            				top: 8,
			            				color: (theme) => theme.palette.grey[500],
			          			}}
			    >
	          		<CloseIcon />
	        	</IconButton>
	        	<DialogContent>
					<YouTube videoId="uqM-7eC3tGc" opts={opts}  />
	        	</DialogContent>
	        	<DialogActions>
						<Button autoFocus 
								variant="contained"
								onClick={handleClose}>
				            {t("OK")}
				        </Button>
	        	</DialogActions>
      		</BootstrapDialog>
		</React.Fragment>
  );
}